import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types"
import {SortDirection} from "../../../../data-structures/sort"
import FieldStatus_PopoverOption from "../../../generic/status/components/popover/option"
import FieldExpenseStatus_ViewSmall from "./render/view-small"
import FieldExpenseStatus_inlineEditable from "./render/inline-editable"
import FieldExpenseApprovalStatus_GListGroupModern from "./components/glist-group/modern"
import FieldExpenseApprovalStatus_GListGroupStandard from "./components/glist-group/standard"
import FieldExpenseApprovalStatus_ConditionForm from "./render/condition"
import {FieldAccess} from "../../../const";
import Expense from "../../../../model2/expenses/expense/expense";
import {ExpenseApprovalStatusOptions} from "../../../../model2/expenses/@const";
import {ColorPalette} from "../../../color-coding/color-coding";

// const debug = "FieldExpenseStatus"
const debug = false

export default class FieldExpenseApprovalStatus extends FieldDropdown {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel          = "Approval status"
        this.filterType         = null
        this.typeGroup          = GROUP_INFO
        // this.typeDescription    = "Status field"
        // this.icon               = 'i5-statuses'
        this.colorPalette       = ColorPalette.STATUS

        this.groupByDefaultSortDirection    = SortDirection.ASC

        this.options            = ExpenseApprovalStatusOptions

        this.noValueOption      = false;

        this.isSearchable       = false;

        this.components.PopoverOption           = FieldStatus_PopoverOption
        this.components.PopoverMenuMore         = null // Not customizable
        this.components.glistGroupModern        = FieldExpenseApprovalStatus_GListGroupModern
        this.components.glistGroupStandard      = FieldExpenseApprovalStatus_GListGroupStandard

        this.renderComponents.inlineEditable    = FieldExpenseStatus_inlineEditable
        this.renderComponents.view              = FieldExpenseStatus_ViewSmall
        this.renderComponents.viewSmall         = FieldExpenseStatus_ViewSmall
        this.renderComponents.glistView         = FieldExpenseStatus_ViewSmall
        this.renderComponents.conditionForm     = FieldExpenseApprovalStatus_ConditionForm

    }


    access(model:Expense) : FieldAccess | false {

        if (this.isDisabled) return FieldAccess.READ

        if (model.acl.canApprove) return FieldAccess.WRITE

        return FieldAccess.READ;
    }


}
